import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ActivityList } from '../../shared/ActivityList'
import { mapTransactionToActivity } from '../../shared/mapTransactionToActivity'
import type { RawActivityTransaction } from '../../shared/mapTransactionToActivity'

interface RecentActivitySectionProps {
  transactions: RawActivityTransaction[]
}

export function RecentActivitySection({ transactions }: RecentActivitySectionProps) {
  const { t, i18n } = useTranslation()

  if (transactions.length === 0) return null

  const entries = transactions.map((tx) => mapTransactionToActivity(tx, t, i18n.language))

  return (
    <View className="gap-3">
      <Text className="text-base font-semibold text-primary">
        {t('stampAwarding.recentActivity.title')}
      </Text>
      <ActivityList entries={entries} />
    </View>
  )
}